import { observer } from 'mobx-react-lite'
import { FormRow } from '@/components/Form'
import { type WorkspaceSignupViewModel } from '@/features/iam/workspaces/WorkspaceSignup/WorkspaceSignupViewModel'
import { MemberSignupView } from '@/features/iam/workspaces/components/MemberSignupView'
import { SignupTextInput } from '@/features/iam/workspaces/components/SignupTextInput'

export interface MemberSignupViewContainerProps {
  vm: WorkspaceSignupViewModel
}

export const MemberSignupViewContainer = observer(
  function MemberSignupViewContainer({ vm }: MemberSignupViewContainerProps) {
    return (
      <MemberSignupView
        onSubmit={vm.submit}
        isSubmitPending={vm.trySyncMember.pending}
      >
        <FormRow>
          <SignupTextInput
            value={vm.givenName}
            onChange={vm.setGivenName}
            label="First Name"
            error={vm.validation.getError('givenName')}
            placeholder="e.g. John"
          />
        </FormRow>
        <FormRow>
          <SignupTextInput
            value={vm.familyName}
            onChange={vm.setFamilyName}
            label="Last Name"
            error={vm.validation.getError('familyName')}
            placeholder="e.g. Smith"
          />
        </FormRow>
        <FormRow>
          <SignupTextInput
            value={vm.email}
            onChange={vm.setEmail}
            label="Email Address"
            error={vm.validation.getError('email')}
            placeholder="john.smith@my-company.com"
          />
        </FormRow>
        <FormRow>
          <SignupTextInput
            value={vm.phone}
            onChange={vm.setPhone}
            label="Phone"
            error={vm.validation.getError('phone')}
            placeholder="(123) 456-7890"
          />
        </FormRow>
      </MemberSignupView>
    )
  },
)
